import { quoteActions } from '../constants/registry/quotes-table.constant';
import {
  DynamicTableBreakpoints,
  DynamicTableConfig,
} from '../interfaces/dynamic-table.interface';
import { compact } from 'lodash';

export const norwayDashboardQuotesTablePreset: Partial<DynamicTableConfig> = {
  columns: [
    { id: 'title' },
    {
      id: 'assignedBroker',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 3,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 2,
        },
      },
    },
    {
      id: 'workflowStatus',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 4,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
          order: 3,
        },
      },
    },
    {
      id: 'lastActivity',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 5,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 4,
        },
      },
    },
    {
      id: 'contextMenu',
      props: {
        actions: [
          quoteActions['viewStatus'],
          quoteActions['assignToBroker'],
          quoteActions['viewProposal'],
          quoteActions['sendInvite'],
        ],
      },
    },
  ],
};

export const norwayQuotesTablePreset: Partial<DynamicTableConfig> = {
  columns: compact([
    { id: 'title' },
    {
      id: 'assignedBroker',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 3,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 2,
        },
      },
    },
    {
      id: 'assignedContacts',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 4,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 3,
        },
      },
    },
    {
      id: 'workflowStatus',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 5,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
          order: 4,
        },
      },
    },
    {
      id: 'lastActivity',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 6,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 5,
        },
      },
    },
    {
      id: 'contextMenu',
      props: {
        actions: compact([
          quoteActions['viewStatus'],
          quoteActions['assignToBroker'],
          quoteActions['assignContact'],
          quoteActions['viewProposal'],
          quoteActions['sendInvite'],
        ]),
      },
    },
  ]),
};
